export class OrderValueModel {
txtOrderValue: string;
setValue(res){
if(res){
if(res['txtOrderValue']){this.txtOrderValue = res['txtOrderValue'];}
}
}
}